var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "selfExamination" }, [
      _c("div", { staticClass: "top" }, [
        _c("img", {
          staticClass: "selfExamination-img",
          attrs: {
            src: require("../../../assets/images/degreeApplication/selfExamination.png"),
            alt: "",
          },
        }),
      ]),
      _c("div", { staticClass: "cont" }, [
        _c("h1", { staticClass: "cont-title" }, [_vm._v("申报条件简述 ")]),
        _c("div", { staticClass: "cont-item cont-top" }, [
          _vm._v(
            " 高等学历继续教育本科毕业生申请授予学士学位，成人高等教育本科毕业生应当在获得本科毕业证书的当年或次年、自考本科毕业生应当在获得本科毕业证书（以毕业证书落款时间为准）1年内提出申请，并符合以下条件： "
          ),
        ]),
        _c("div", { staticClass: "cont-item cont-1" }, [
          _vm._v(
            " （一）热爱祖国，拥护中国共产党的领导，拥护社会主义制度，遵纪守法，品行端正，遵守学术道德和学术规范。 "
          ),
        ]),
        _c("div", { staticClass: "cont-item" }, [
          _vm._v(" （二）课程考试（核）成绩要求。 "),
        ]),
        _c("div", { staticClass: "cont-item cont-3" }, [
          _c("p", [
            _vm._v(
              "1. 成人高等教育本科毕业生课程平均成绩≥70分（含毕业理论考试成绩、毕业论文成绩）;"
            ),
          ]),
          _c("p", [
            _vm._v(
              "2. 高等教育自学考试本科毕业生课程平均成绩≥70分，临床实习、毕业论文成绩均≥75分（免实习的考生，其“临床实习”成绩视为75分）。高等教育自学考试考生所有课程成绩认定时间均以取得自考本科毕业证书上毕业日期之前的考试成绩为准。"
            ),
          ]),
        ]),
        _c("div", { staticClass: "cont-item" }, [
          _vm._v(" （三）外语成绩要求。 "),
        ]),
        _c("div", { staticClass: "cont-item cont-3" }, [
          _c("p", [
            _vm._v(
              "成人高等教育学生取得本科学籍后，至申请学位前；自考学生取得本科阶段第一门课程合格成绩后，至获得毕业证书前，满足下列条件之一："
            ),
          ]),
        ]),
        _c("div", { staticClass: "cont-item cont-3" }, [
          _c("p", [
            _vm._v(
              " 1. 自考学生高等教育自学考试“英语（专升本）”课程，成绩≥70分； "
            ),
          ]),
          _c("p", [_vm._v(" 2. 全国大学英语四级及以上考试，成绩≥350分； ")]),
          _c("p", [
            _vm._v(" 3. 全国英语等级考试（PETS）三级及以上，笔试成绩合格； "),
          ]),
          _c("p", [
            _vm._v(" 4. 医学英语水平考试（METS）三级及以上，成绩合格。 "),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }